import SSSlide from "./00-slideshare_slide";

function SSIframeSlide(config){
  SSSlide.call(this,config);
  this.loaded = false;
  this.$iframe  = $('#'+config.iframe_id);
  this.bindEvents();
}

SSIframeSlide.prototype = new SSSlide();

SSIframeSlide.prototype.bindEvents = function(){
  var that = this;
  // set iframe height to the height of the content inside it after it's loaded
  this.$iframe.load(function(){
    that.loaded = true;
    that.showIframe();
  });
};

SSIframeSlide.prototype.showIframe = function(){
  if(this.$imageEle){
    this.$imageEle.hide();
  }

  //using .show() sets display:inline which is not desired
  this.$iframe.css("display", "block");
};

SSIframeSlide.prototype.next = function(){
  this.$iframe.contents().find("body").trigger("next");
};

SSIframeSlide.prototype.previous = function(){
  this.$iframe.contents().find("body").trigger("previous");
};

SSIframeSlide.prototype.empty = function(){};

SSIframeSlide.prototype.setContainer = function(config){};

SSIframeSlide.prototype.show = function(force){
};

SSIframeSlide.prototype.hide = function(){};

SSIframeSlide.prototype.displayLoading = function(){};

SSIframeSlide.prototype.reloadIframe = function(){
  var $newIframe = this.$iframe.clone();
  this.$iframe.replaceWith($newIframe);
};

export default SSIframeSlide;
